<template>
  <page-edicion>
    <page-header :title="formaPago.nombre" subtitle="Forma de pago" back-to="/formasPago" />
    <formulario-forma-pago :forma-pago="formaPago" @submit="actualizar" />
  </page-edicion>
</template>

<script>
import FormularioFormaPago from "./FormularioFormaPago.vue";
import api from "@/services/formasPago.js";

export default {
  components: { FormularioFormaPago },
  data() {
    return {
      formaPago: {},
    };
  },
  mounted() {
    this.cargar(this.$route.params.id);
  },
  methods: {
    cargar(id) {
      api.cargar(id).then((response) => {
        this.formaPago = response.formaPago;
      });
    },
    actualizar() {
      api.actualizar(this.formaPago).then(() => {
        this.$messages.success("Se ha actualizado la forma de pago");
        this.$router.push({ path: "/formasPago" });
      });
    },
  },
};
</script>
